import { render, staticRenderFns } from "./OnboardingInstallationZeroDataModal.vue?vue&type=template&id=01f35250&scoped=true"
import script from "./OnboardingInstallationZeroDataModal.vue?vue&type=script&lang=js"
export * from "./OnboardingInstallationZeroDataModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingInstallationZeroDataModal.vue?vue&type=style&index=0&id=01f35250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f35250",
  null
  
)

export default component.exports